import React, { forwardRef } from 'react';
import styled, { css } from 'styled-components';

import { breakPoint } from '../../../assets/js/constants';
import { layoutIndent as indent } from '../../../assets/js/constants';
import { wideBreakpoints } from '../wideContainer';

const MODE_WIDE = 'wide';
const MODE_DEFAULT = 'default';

/**
 * Получает отступы
 * @param {Object} config
 * @param {number} config.value
 * @param {boolean} [config.fullwidth]
 */
const getPadding = ({ value, fullwidth }) => {
    const padding = fullwidth ? '0' : `${value}px`;

    return css`
        padding-left: ${padding};
        padding-right: ${padding};
    `;
};

const Container = styled.div`
    margin-left: auto;
    margin-right: auto;
    ${({ fullwidth }) => getPadding({ value: indent, fullwidth })}

    ${p => p.modeName === MODE_WIDE
        ? css`
            width: 1568px;

            @media (max-width: ${wideBreakpoints.sDesktop}) {
                width: 1280px;
            }

            @media (max-width: ${wideBreakpoints.laptop}) {
                width: 1000px;
            }

            @media (max-width: ${wideBreakpoints.tablet}) {
                ${({ fullwidth }) => getPadding({ value: indent / 2, fullwidth })}
                width: 768px;
            }

            @media (max-width: ${wideBreakpoints.mobile}) {
                width: 100%;
            }

            @media (max-width: ${wideBreakpoints.sMobile}) {
                ${({ fullwidth }) => getPadding({ value: indent / 4, fullwidth })}
            }
        `
        : css`
            width: ${1360 + indent * 2}px;

            @media(${breakPoint(1366, MODE_DEFAULT)}) {
                width: ${1032 + indent * 2}px;
            }

            @media(${breakPoint(1024, MODE_DEFAULT)}) {
                width: ${800 + indent * 2}px;
            }

            @media(${breakPoint(768, MODE_DEFAULT)}) {
                width: 94.221%;
                min-width: ${592 + indent * 2}px;
            }

            @media(${breakPoint(320, MODE_DEFAULT)}) {
                ${({ fullwidth }) => getPadding({ value: indent / 2, fullwidth })}
                width: 98.594%;
                min-width: 320px;
            }
        `
    }
`;

/**
 * @deprecated
 * Использовать новый компонент сетки src/components/layouts/wideContainer
 * */
const Component = forwardRef((props, ref) => <Container ref={ref} {...props}/>);

Component.displayName = 'ForwardedComponent';
export default Component;
